export const userInputs = [
    {
      id: "username",
      label: "Username",
      type: "text",
      placeholder: "john_doe",
    },
    {
      id: "displayName",
      label: "Name and surname",
      type: "text",
      placeholder: "John Doe",
    },
    {
      id: "email",
      label: "Email",
      type: "mail",
      placeholder: "john_doe@gmail.com",
    },
    {
      id: "phone",
      label: "Phone",
      type: "text",
      placeholder: "+1 234 567 89",
    },
    {
      id: "password",
      label: "Password",
      type: "password",
    },
    {
      id: "address",
      label: "Address",
      type: "text",
      placeholder: "Elton St. 216 NewYork",
    },
    {
      id: "country",
      label: "Country",
      type: "text",
      placeholder: "USA",
    },
  ];
  
  export const pagosInputs = [
    {
      id: 1,
      label: "Nombre del Pagador",
      type: "text",
      placeholder: "Juan Pérez",
    },
    {
      id: 2,
      label: "Correo Electrónico del Pagador",
      type: "email",
      placeholder: "juanperez@example.com",
    },
    {
      id: 3,
      label: "Monto",
      type: "number",
      placeholder: "100.00",
    },
    {
      id: 4,
      label: "Método de Pago",
      type: "text",
      placeholder: "Tarjeta de Crédito",
    },
    {
      id: 5,
      label: "Fecha de Pago",
      type: "date",
      placeholder: "",
    },
    {
      id: 6,
      label: "ID de Transacción",
      type: "text",
      placeholder: "1234567890",
    },
  ];
  